import { lazy } from 'react';

// project imports
import CandidateLayout from 'layout/CandidateLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import PortalThemeProvider from 'themes/PortalThemeProvider';

// Dashboard
const Dashboard = Loadable(lazy(() => import('views/candidate-portal/dashboard')));
const Instructions = Loadable(lazy(() => import('views/candidate-portal/Instructions')));
const EvidenceManagement = Loadable(lazy(() => import('views/candidate-portal/evidence')));
const AdditionalEvidenceRequests = Loadable(lazy(() => import('views/candidate-portal/additional-evidence-requests')));
const EvidenceResubmission = Loadable(lazy(() => import('views/candidate-portal/resubmit-evidence')));
const WorkExperience = Loadable(lazy(() => import('views/candidate-portal/WorkExperience')));
const Main = Loadable(lazy(() => import('views/candidate-portal/Main')));
const Appeal = Loadable(lazy(() => import('views/candidate-portal/Appeal')));

const Error404 = Loadable(lazy(() => import('views/error/Error404')));

const CandidateRoutes = {
    path: '/',
    errorElement: (
        <PortalThemeProvider>
            <Error404 />
        </PortalThemeProvider>
    ),
    element: (
        <PortalThemeProvider>
            <AuthGuard allowedPrincipalTypes={['candidate']}>
                <CandidateLayout />
            </AuthGuard>
        </PortalThemeProvider>
    ),
    children: [
        {
            path: '/candidate/:assessmentCode',
            children: [
                {
                    path: '',
                    element: <Main />
                },
                {
                    path: 'instructions',
                    element: <Instructions />
                },
                {
                    path: 'work-experience',
                    element: <WorkExperience />
                },
                {
                    path: 'start',
                    element: <Dashboard />
                },
                {
                    path: 'main',
                    element: <Main />
                },
                {
                    path: 'appeal',
                    element: <Appeal />
                },
                {
                    path: 'evidence-management',
                    element: <EvidenceManagement />
                },
                {
                    path: 'additional-evidence-requests',
                    element: <AdditionalEvidenceRequests />
                },
                {
                    path: 'resubmit-evidence',
                    element: <EvidenceResubmission />
                }
            ]
        }
    ]
};

export default CandidateRoutes;
